import React from "react";
import TextField from "@mui/material/TextField";

const GALLONS_PER_ACRE_FOOT = 325851;

export function AcreFeetEditCell(props) {
  const { id, value, field, api } = props;

  const handleChange = (event) => {
    const acreFeet = Number(event.target.value);
    api.setEditCellValue({ id, field, value: acreFeet });
    api.setEditCellValue({
      id,
      field: "permit_gpy",
      value: isNaN(acreFeet)
        ? ""
        : Math.round(acreFeet * GALLONS_PER_ACRE_FOOT),
    });
  };

  return (
    <TextField
      value={value ?? ""}
      onChange={handleChange}
      type="number"
      slotProps={{
        htmlInput: { min: 0 },
        input: {
          disableUnderline: true,
        },
      }}
      variant="standard"
      sx={{
        justifyContent: "center",
        padding: "0px 16px",
      }}
    />
  );
}

export function GpyEditCell(props) {
  const { id, value, field, api } = props;

  const handleChange = (event) => {
    const gpy = Number(event.target.value);
    api.setEditCellValue({ id, field, value: gpy });
    api.setEditCellValue({
      id,
      field: "permit_acre_feet",
      value: isNaN(gpy) ? "" : Number((gpy / GALLONS_PER_ACRE_FOOT).toFixed(2)),
    });
  };

  return (
    <TextField
      value={value ?? ""}
      onChange={handleChange}
      type="number"
      slotProps={{
        htmlInput: { min: 0 },
        input: {
          disableUnderline: true,
        },
      }}
      variant="standard"
      sx={{
        justifyContent: "center",
        padding: "0px 16px",
      }}
    />
  );
}
